import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconHamburger: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M3.35992 3.84009C2.56492 3.84009 1.91992 4.48509 1.91992 5.28009C1.91992 6.07509 2.56492 6.72009 3.35992 6.72009H20.6399C21.4349 6.72009 22.0799 6.07509 22.0799 5.28009C22.0799 4.48509 21.4349 3.84009 20.6399 3.84009H3.35992ZM3.35992 10.5601C2.56492 10.5601 1.91992 11.2051 1.91992 12.0001C1.91992 12.7951 2.56492 13.4401 3.35992 13.4401H20.6399C21.4349 13.4401 22.0799 12.7951 22.0799 12.0001C22.0799 11.2051 21.4349 10.5601 20.6399 10.5601H3.35992ZM3.35992 17.2801C2.56492 17.2801 1.91992 17.9251 1.91992 18.7201C1.91992 19.5151 2.56492 20.1601 3.35992 20.1601H20.6399C21.4349 20.1601 22.0799 19.5151 22.0799 18.7201C22.0799 17.9251 21.4349 17.2801 20.6399 17.2801H3.35992Z"
        fill={fill || '#262626'}
      />
    </Icon>
  );
};

export default IconHamburger;
